import React from 'react';
import RichTextBody from './RichTextComponents';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/Modal.css';

// This component is used to display a modal with an image and its details
const CustomModalHeroUnit: React.FC<{
  show: boolean;
  onHide: () => void;
  element: any;
}> = ({ show, onHide, element }) => {
  const digitalAssetImage =
    element.digital_asset___image?.linkedItems[0]?.elements?.image_asset
      ?.value[0]?.url;
  const digitalAssetDesc =
    element.digital_asset___image?.linkedItems[0]?.elements?.image_asset
      ?.value[0]?.description || 'Image';
  const digitalAssetTitle =
    element.digital_asset___image?.linkedItems[0]?.elements?.title?.value;
  const digitalAssetId =
    element.digital_asset___image?.linkedItems[0]?.elements?.digital_asset_id
      ?.value;
  const digitalAssetPermLang =
    element.digital_asset___image?.linkedItems[0]?.elements
      ?.image_permission_language;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="modal-N100DF"
      role="dialog"
      tabIndex={-1}
      backdrop={true} // Allows clicking outside to close the modal
      keyboard={true} // Allows closing with the Escape key
      className="modal-fade in"
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
      centered
    >
      <div className="modal-content">
        <Modal.Header className="modal-header">
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={onHide}
            style={{
              background: 'none',
              border: 'none',
              color: '#000',
              opacity: 0.5,
              cursor: 'pointer',
            }}
          >
            &times;
          </button>
          {digitalAssetTitle && (
            <Modal.Title id="modal-N100DF" className="modal-title">
              {digitalAssetTitle}
            </Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          {element.digital_asset___image?.linkedItems[0]?.elements?.image_asset
            ?.value[0]?.url ? (
            <img
              src={digitalAssetImage}
              alt={digitalAssetDesc}
              className="img-responsive center-block"
            />
          ) : (
            <p>No image available</p>
          )}
        </Modal.Body>
        {(digitalAssetId || digitalAssetPermLang) && (
          <Modal.Footer className="modal-footer">
            <span className="daid">
              <RichTextBody element={digitalAssetPermLang} /> [{digitalAssetId}]
            </span>
          </Modal.Footer>
        )}
      </div>
    </Modal>
  );
};

export default CustomModalHeroUnit;
